import { z } from "zod";
import { ERP_SYNC_CONFIG_PROPERTY_ORDER, ERPSyncConfigSchema } from "./schemas";

/**
 * Per-customer Odyssey sync configuration. Stored as `integrationConfig` jsonb
 * on the `erpIntegrationSyncsTable` row. Extends the shared
 * {@link ERPSyncConfigSchema} with the overhead basis of imported operation rates.
 */
export const OdysseySyncConfigSchema = ERPSyncConfigSchema.extend({
  includeFixedOverhead: z.boolean().default(true).meta({
    title: "Include fixed overhead in operation rates",
    description:
      "Import fixed overhead alongside variable overhead as operation burden. Turn off to import variable overhead only.",
  }),
});

/** Per-customer Odyssey sync configuration. */
export type OdysseySyncConfig = z.infer<typeof OdysseySyncConfigSchema>;

/** Display order for the Odyssey sync config properties. */
export const ODYSSEY_SYNC_CONFIG_PROPERTY_ORDER: string[] = [
  ...ERP_SYNC_CONFIG_PROPERTY_ORDER,
  "includeFixedOverhead",
];
